<template>
    <div class="login" :style="{ backgroundImage: `url(${theme.loginBgColor})` }" @click.stop="onClickCaptcha()">
        <login-card class="login--left--card" ref="loginCardRef"></login-card>
    </div>
    <Footer></Footer>
</template>

<script setup lang="ts">
import LoginCard from "./loginCard.vue";
import Footer from "@/views/components/sassFooter/index.vue";
import { theme } from "@/config/sassTheme";
import { ref } from "vue";
const loginCardRef = ref();
/** 关闭验证码 */
const onClickCaptcha = () => {
    loginCardRef.value?.onClickClostCaptcha();
};
</script>

<style scoped lang="scss">
.login {
    width: 100vw;
    min-height: calc(100vh - 46px);
    display: flex;
    background-size: cover;
    &--left {
        width: 33.7%;
        background: #fafafa;
    }
    &--right {
        width: 66.3%;
        background-size: cover;
    }
}
</style>
